import { useCallback } from 'react';

type PageParams = {
  pageIndex: number;
};

const useResetToFirstPageOrRefresh = <T extends PageParams>(
  params: T,
  setParams: (params: Partial<T>) => void,
  refresh: () => void | Promise<unknown>
) =>
  useCallback(() => {
    if (params.pageIndex !== 1) {
      setParams({ pageIndex: 1 } as Partial<T>);
      return;
    }
    refresh();
  }, [params.pageIndex, refresh, setParams]);

export default useResetToFirstPageOrRefresh;
